import { render, staticRenderFns } from "./BillOfLading.vue?vue&type=template&id=2989b68d&scoped=true&"
import script from "./BillOfLading.vue?vue&type=script&lang=ts&"
export * from "./BillOfLading.vue?vue&type=script&lang=ts&"
import style0 from "./BillOfLading.vue?vue&type=style&index=0&id=2989b68d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2989b68d",
  null
  
)

export default component.exports